module.exports = __webpack_public_path__ + "img/bottom.57d685bd.png";